const NoResults1Enum = Object.freeze({
  Čeština:
    'V současné době nejsou k dispozici žádné volné pozice, které by odpovídaly vašemu vyhledávání. Vymažte prosím filtry nebo začněte nové vyhledávání.',
  Deutsch:
    'Derzeit gibt es keine offenen Stellen, die Ihrer Suche entsprechen. Bitte löschen Sie Ihre Filter oder starten Sie eine neue Suche.',
  Français:
    "Il n'y a actuellement aucun poste ouvert correspondant à votre recherche. Veuillez supprimer vos filtres ou lancer une nouvelle recherche.",
  Slovenčina:
    'V súčasnosti nie sú k dispozícii žiadne voľné pracovné pozície, ktoré by zodpovedali vášmu vyhľadávaniu. Vymažte prosím filtre alebo začnite nové vyhľadávanie.',
  Español:
    'Actualmente no hay puestos vacantes que coincidan con su búsqueda. Por favor, borre sus filtros o inicie una nueva búsqueda.',
  English:
    'There are currently no open positions matching your search. Please try different keywords, clear your filters, or start a new search.',
})

export default NoResults1Enum
